<script>
import Form from '../Form.vue';

export default {
    extends: Form,

    data() {
        return {
           search: '',
        };
    },

    props: {
        customers: {
            type: Array,
            required: true,
        },
    },

    computed: {
        visibleCustomers() {
            const query = this.search.toLowerCase();

            if (!query) {
                return this.customers;
            }

            return this.customers.filter(customer => customer.label.toLowerCase().includes(query));
        },
    },
};
</script>
